import currentProjectData from "../../scripts/portfolio-sites.json";

import relevanceImg from "../assets/img/portfolio/relevance-protocol.png";
import pliImg from "../assets/img/portfolio/precision-lead-intelligence.png";
import litespeedImg from "../assets/img/portfolio/litespeed-construction.png";
import cleanCanImg from "../assets/img/portfolio/clean-can-tn.png";
import mountainImg from "../assets/img/portfolio/mountain-mixology.png";
import charlesImg from "../assets/img/portfolio/charles-brown-recruitment.png";
import kiteWoodImg from "../assets/img/portfolio/kite-wood-design.png";
import cottageImg from "../assets/img/portfolio/cottage-kitchen-sweets.png";
import amberImg from "../assets/img/portfolio/amber-robinson-realtor.png";

import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import projImg4 from "../assets/img/project-img4.png";
import projImg5 from "../assets/img/project-img5.png";
import projImg6 from "../assets/img/project-img6.png";
import projImg7 from "../assets/img/project-img7.png";
import projImg8 from "../assets/img/project-img8.png";
import projImg9 from "../assets/img/project-img9.png";

const currentProjectImages = {
  "relevance-protocol": relevanceImg,
  "precision-lead-intelligence": pliImg,
  "litespeed-construction": litespeedImg,
  "clean-can-tn": cleanCanImg,
  "mountain-mixology": mountainImg,
  "charles-brown-recruitment": charlesImg,
  "kite-wood-design": kiteWoodImg,
  "cottage-kitchen-sweets": cottageImg,
  "amber-robinson-realtor": amberImg,
};

const currentProjects = currentProjectData.map(({ id, title, description, url }) => ({
  title,
  description,
  url,
  imgUrl: currentProjectImages[id],
}));

const legacyProjects = [
  {
    title: "Recruitment Firm",
    description: "WordPress Design & Development, Logo Design",
    imgUrl: projImg4,
    url: "",
  },
  {
    title: "E-commerce Website",
    description: "WordPress Design & Development, Logo Design",
    imgUrl: projImg5,
    url: "",
  },
  {
    title: "Recruitment Firm",
    description: "WordPress Design & Development",
    imgUrl: projImg6,
    url: "",
  },
  {
    title: "Travel Booking Website",
    description: "WordPress Design & Development, Logo Design",
    imgUrl: projImg8,
    url: "",
  },
  {
    title: "React Application",
    description: "React Decision Application",
    imgUrl: projImg7,
    url: "",
  },
  {
    title: "E-commerce Website",
    description: "Woocommerce + WordPress Development",
    imgUrl: projImg9,
    url: "",
  },
  {
    title: "Travel Landing Page Concept",
    description: "Responsive Landing Page Design",
    imgUrl: projImg1,
    url: "",
  },
  {
    title: "Agency Landing Page Concept",
    description: "Responsive Marketing Website Design",
    imgUrl: projImg2,
    url: "",
  },
  {
    title: "Startup Landing Page Concept",
    description: "Responsive Product Website Design",
    imgUrl: projImg3,
    url: "",
  },
];

export const projects = [...currentProjects, ...legacyProjects];
